/**
 * @module components/Form/FormGroupYear
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Form group for getting year
 */

import React from 'react';

import {
  Col, FormGroup, ControlLabel, FormControl,
  InputGroup, OverlayTrigger, Popover, Button, Table
} from 'react-bootstrap';

import { useLanguageState } from '../../contexts/language-state-provider';

import { useAppState } from '../../contexts/app-state-provider';


type Props = {
  value: string,
  onChange: React.FormEventHandler<FormControl>
}

/**
 * React component
 * ===============
 */
const FormGroupModels = ({
  value,
  onChange
}: Props) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();

  const popovertr = Object.keys(state.form.codeMap).map(code => {
    return (
      <tr key={code}>
        <td>{lang.codeMap[code]}</td>
        <td>{lang.modelMap[state.form.codeMap[code]]}</td>
      </tr>
    )
  })

  const popover = (
    <Popover id="model-popover">
      <Table bordered>
        <thead>
          <tr>
            <th>Code</th>
            <th>{lang.summary.model}</th>
          </tr>
        </thead>
        <tbody>
          { popovertr }
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={2}><small>{lang.modelNotice}</small></td>
          </tr>
        </tfoot>
      </Table>
    </Popover>
  );

  return (
    <FormGroup
      controlId="code"
    >
      <Col componentClass={ControlLabel} sm={2}>
        {lang.form.code}
      </Col>
      <Col sm={4}>
        <InputGroup>
          <FormControl
            componentClass="select"
            placeholder="select"
            value={value}
            onChange={onChange}
          >
            {Object.keys(state.form.codeMap).map((code) =>
              <option key={code} value={code}>{lang.codeMap[code]}</option>
            )}
          </FormControl>
          <InputGroup.Button>
            <OverlayTrigger
              trigger="click"
              placement="right"
              overlay={popover}
            >
              <Button>
                <span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
                <span className="hidden">{lang.form.help}</span>
              </Button>
            </OverlayTrigger>
          </InputGroup.Button>
        </InputGroup>
      </Col>
    </FormGroup>
  );
}

export default FormGroupModels;
